import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContratoAppRoutingModule } from './contrato.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ContratoAppRoutingModule
  ]
})
export class ContratoAppModule { }
